<template>
  <access-code-view title="Public Display" target-page="tv" />
</template>

<script>
import AccessCodeView from '../components/Common/AccessCodeView.vue';

export default {
  components: { AccessCodeView },
  mixins: [],
  props: {},
  data: () => {
    return {};
  }
};
</script>
